import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addAccessorial, AddAccessorialApiParameters } from "@tKgpco/Services/AccessorialsService";
import { updateDiscrepancy, UpdateDiscrepancyApiParameter } from "@tKgpco/Services/DiscrepancyService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Accessorials } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = UpdateDiscrepancyApiParameter & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, any>;

export const PopulateApiParameters: HandlerType = props => {
    const { discrepancyId, discrepancyStatus, closedDate } = props.parameter;
    props.apiParameter = {
        discrepancyId,
        discrepancyStatus,
        ...(closedDate && { closedDate }),
    };
};

export const UpdateStatus: HandlerType = async props => {
    try {
        await updateDiscrepancy(props.parameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, UpdateStatus, ExecuteOnSuccess];

const updateDiscrepancyStatus = createHandlerChainRunner(chain, "UpdateDiscrepancyStatus");
export default updateDiscrepancyStatus;
